import { Radio, TrendingUp, Sparkles, User } from 'lucide-react';

interface BottomNavProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}

export default function BottomNav({ activeTab, onTabChange }: BottomNavProps) {
  const tabs = [
    { id: 'signal', label: '信号厅', icon: Radio },
    { id: 'oneil', label: '欧奈尔', icon: TrendingUp },
    { id: 'magic', label: '股魔', icon: Sparkles },
    { id: 'profile', label: '我的', icon: User }
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-card border-t border-border h-14 flex items-center justify-around shadow-[0_-2px_10px_rgba(0,0,0,0.1)] z-50">
      {tabs.map((tab) => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;
        
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`flex flex-col items-center justify-center flex-1 h-full transition-colors ${
              isActive ? 'text-[#1a56db]' : 'text-muted-foreground'
            }`}
          >
            <Icon className="w-5 h-5 mb-0.5" />
            <span className="text-xs">{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
